import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { useForm } from '@inertiajs/vue3';
    import { WorkCalendar } from '@/types';
    import DialogForm from '@/components/DialogForm.vue';
    import WorkCalendarForm from './WorkCalendarForm.vue';
    import QueryKey from '@/enums/QueryKey';

    
export default /*@__PURE__*/_defineComponent({
  __name: 'EditWorkCalendar',
  props: {
    workCalendar: {}
  },
  setup(__props: any) {

    const props = __props;

    const form = useForm({
        name: props.workCalendar.name,
    });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(DialogForm, {
    type: "update",
    form: _unref(form),
    route: _ctx.route('v2.salary.work-calendars.update', _ctx.workCalendar.id),
    method: "patch",
    "query-key": [_unref(QueryKey).WORK_CALENDARS],
    title: "work-calendars.update"
  }, {
    default: _withCtx(() => [
      _createVNode(WorkCalendarForm, { form: _unref(form) }, null, 8, ["form"])
    ]),
    _: 1
  }, 8, ["form", "route", "query-key"]))
}
}

})